export function getSchoolFromUrl() {
  const url = window.location.pathname;
  const school = url.split('/')[1]; // Assuming the school name is the first part of the pathname
  return school ? school : null;
}
